import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs/Observable';
import { ConfigClass } from './config.class';

export class CacheMode {
  public maxAge: number;
  public mode: string;

  public static Reconstruct(headerValue: string): CacheMode {
    const vals = headerValue.split(',');
    const maxxAge = vals[1].split('=');
    return new CacheMode(vals[0], Number(maxxAge[1]));
  }

  constructor(mode: string, maxAgeInSecounds: number) {
    this.maxAge = maxAgeInSecounds,
      this.mode = mode;
  }

  public get AsHeaderValue(): string {
    return this.mode + ', max-age=' + this.maxAge;
  }
}

export class CacheTypes {
  public static NoCache: CacheMode = new CacheMode('no-cache', 0);
  public static ShortPrivateCache: CacheMode = new CacheMode('private', 30);
  public static LongPrivateCache: CacheMode = new CacheMode('private', 600);
}

export abstract class RESTServiceBase {
  auth: AuthService;
  protected constructor(
    private apiVersion: string,
    private featureName: string,
    auth: AuthService,
    private conf: ConfigClass
  ) {
    this.auth = auth;
  }

  protected get<T>(id?: string, queryObject?: any, commandPath?: string, cache: CacheMode = CacheTypes.NoCache): Promise<T> {
    return this.auth.get(this.buildUrl(id, commandPath), queryObject, cache);
  }

  protected post<T>(payload?: any, id?: string, commandPath?: string, cache: CacheMode = CacheTypes.NoCache): Promise<T> {
    return this.auth.post(this.buildUrl(id, commandPath), payload, cache);
  }

  protected put<T>(id: string, payload: any, commandPath?: string, cache: CacheMode = CacheTypes.NoCache): Promise<T> {
    return this.auth.put(this.buildUrl(id, commandPath), payload, cache);
  }

  protected patch<T>(id: string, payload: any, commandPath?: string, cache: CacheMode = CacheTypes.NoCache): Promise<T> {
    return this.auth.patch(this.buildUrl(id, commandPath), payload, cache);
  }

  protected delete(id: string, commandPath?: string, cache: CacheMode = CacheTypes.NoCache): Promise<any> {
    return this.auth.delete(this.buildUrl(id, commandPath), cache);
  }

  protected uploadFiles(files: Set<File>, id?: string): { [key: string]: Observable<number> } {
    return this.auth.upload(this.buildUrl(id), files);
  }

  protected checkHealth() {
    return this.auth.get<any>(this.buildUrl('Health', undefined, true));
  }

  protected async isServiceAvailable(): Promise<boolean> {
    try {
      await this.checkHealth();
    } catch (error) {
      return false;
    }

    return true;
  }

  protected buildUrl(id?: string, commandPath?: string, healthCheck?: boolean): string {

    if (this.featureName) {
      let url = `${this.conf.url}/${this.apiVersion}/${this.featureName}`;
      if (healthCheck) {
        url = `${this.conf.url}/${this.apiVersion}`;
      }
      if (id) { url += '/' + id; }
      if (commandPath) { url += '/' + commandPath; }

      return url;
    }
    console.error('service base should be initialized first!');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/service.base.ts